var handle_array = ["breitling-emergency-k76321-43mm-black-dial-with-yellow-gold-bracelet","rolex-daytona-116505-40mm-champagne-dial-with-rose-gold-oyster-bracelet","10k-white-gold-unisex-pendant-with-8-2-ct-diamonds","14k-yellow-gold-unisex-pendant-with-8-2-ct-diamonds","14k-yellow-white-gold-unisex-pendant-with-9-5-ct-diamonds","14k-yellow-gold-unisex-pendant-with-10-95-ct-diamonds","14k-rose-gold-unisex-pendant-with-16-ct-diamonds","10k-yellow-white-gold-unisex-pendant-with-8-20-ct-diamonds","10k-rose-gold-diamond-custom-3d-coin-pendant-18-ct","14k-yellow-gold-diamond-name-pendant-2-50-ct"];
 var productid_array = ["3861401042988","7215992045752","7216000172216","7216001548472","7217662984376","7217669341368","7217884692664","7260900950200","7260915597496"];
 var collectionid_array = ["292512759992"];
 var product_tags_array = [""];
 var hide_price=1;
 var hide_ajaxaddtocart=1;
 var display_phone=1;
 var phone_no = '+1-844-330-9466';
 var display_call_for_price = 1;
 var call_for_price_label = 'Call for Price';
 var css_style_button='background-color: #000000;color:#ffffff;';
 var enabled_captcha = 0;
 var site_key = '';
 var recaptcha_ver = 'v2';
 var thankyou_msg = 'Please call us at +1-844-330-9466 for more information.';
 var thankyou_header = 'Thank You';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comments';
 var submit_label ='Submit';
  var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = '';
 var enable_app =1;
  var enable_outofstock = 1;
 var price_selector='.gf_product-price money';
 var cart_selector='.gf_add-to-cart .product-form-product-template .button .btn';
  var phone_no_label = 'Call for Price:';
 var required_field='name,phone';
 var contact_form_heading='Call For Price Form';
 var parent_selector='.gf_product-title';
 var unavailable_label='Unavailable';
 var show_price='no';
 var enable_cfp_for_zero_price_prd='no';
 var enable_cfp_for_all_products='no';
 var enable_cfp_soldout_products='no';
 var hide_cfp_btn_on_collection='no';
 var hide_phone_no_on_collection='no';
 var enable_whatsapp = 0;
 var whatsapp_number = '';
 var whatsapp_message = '';
 var hide_whatsapp_button_on_collection = 0;
 var whatsapp_button_text ='';
 var whatsapp_button_background_color ='#000000';
 var whatsapp_button_text_color ='#ffffff';
 var whatsapp_css_style_button ='';
 var phoneno_css_style_button ='';